import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

(function() {
  const pingGA = (label: string, nonInteraction: boolean) => {
    if (window['gtag']) {
      window['gtag'](
        'event',
        `time_on_page:${label.split(' ').join('_')}`,
        {
          'event_category': 'time_on_page',
          'event_label': label,
          'non_interaction': nonInteraction
        }
      );
    }
  }

  const timesSpent: {
    label: string;
    timeout: number;
    nonInteraction: boolean;
  }[] = [
    {
      label: '0-10 seconds',
      timeout: 0,
      nonInteraction: true
    },
    {
      label: '11-30 seconds',
      timeout: 11000,
      nonInteraction: true
    },
    {
      label: '31-60 seconds',
      timeout: 31000,
      nonInteraction: true
    },
    {
      label: '61-180 seconds',
      timeout: 61000,
      nonInteraction: false
    },
    {
      label: '181-600 seconds',
      timeout: 181000,
      nonInteraction: false
    },
    {
      label: '601-1800 seconds',
      timeout: 601000,
      nonInteraction: false
    },
    {
      label: '1801+ seconds',
      timeout: 1801000,
      nonInteraction: false
    },
  ];

  timesSpent.forEach(
    (timeSpent) => setTimeout(
      () => pingGA(timeSpent.label, timeSpent.nonInteraction)
      , timeSpent.timeout
    )
  );

  const currentUrl = new URL(`${document.location}`);
  const lang =
    currentUrl.searchParams.get('locale') ||
    currentUrl.searchParams.get(
      'com.veriday.digitalagent.web.locale.override'
    ) || window['locale'];
  window['locale'] = lang ?
    lang.split('_')[0] :
    window.location.host === 'www1.digitalagent.ca' ? 'en' : 'fr';

  const loaded = function() {
    const navBar =
      document.getElementById('header') || document.createElement('div');
    const cta = document.getElementById('cta') || document.createElement('div');
    const scrollHint = document.getElementsByClassName('scroll-hint').item(0) ||
                       document.createElement('div');

    let mobileNavToggleButton: HTMLButtonElement;
    const mobileNavToggleButtonList = document.getElementById(
      'da-nav-toggle'
    );
    if (mobileNavToggleButtonList) {
      mobileNavToggleButton =
        mobileNavToggleButtonList.children[0] as HTMLButtonElement;
    }

    const teamSection = document.getElementById('team');
    if (teamSection) {
      let teamSectionTop: number;

      const teamNav = document.querySelectorAll(
        'a[href^="/team"], a[href^="/web/demosfamilywealthmanagement/team"]'
      ) as NodeListOf<HTMLAnchorElement>;

      if (teamNav.length) {
        teamNav.forEach(
          (el) => {
            el.setAttribute('href', '#team');

            el.onclick = (e: Event) => {
              e.preventDefault();

              if (
                mobileNavToggleButton &&
                !mobileNavToggleButton.classList.contains('collapsed')
              ) {
                mobileNavToggleButton.click();
              }

              if (!teamSectionTop) {
                const navHeight = window.innerWidth < 768 ?
                  (90 * window.devicePixelRatio) :
                  (140 * window.devicePixelRatio);

                teamSectionTop =
                  teamSection.getBoundingClientRect().top - navHeight;
              }

              jQuery('html, body').animate({
                scrollTop: teamSectionTop
              }, 1000);
            }
          }
        );
      } 
    } else {
      const teamNav = document.querySelectorAll(
        'a[href^="/team"]'
      ) as NodeListOf<HTMLAnchorElement>;

      const teamNavDemos = document.querySelectorAll(
        'a[href^="/web/demosfamilywealthmanagement/team"]'
      ) as NodeListOf<HTMLAnchorElement>;

      if (teamNav.length) {
        teamNav.forEach(
          (el) => el.setAttribute('href', '#team')
        )
      }

      if (teamNavDemos.length) {
        teamNavDemos.forEach(
          (el) => el.setAttribute('href', '/web/demosfamilywealthmanagement/#team')
        )
      }
    }

    window.addEventListener('scroll', function(e: Event) {
      const scrollHeight = Math.max(
        document.body.scrollHeight, document.documentElement.scrollHeight,
        document.body.offsetHeight, document.documentElement.offsetHeight,
        document.body.clientHeight, document.documentElement.clientHeight
      );

      if (window.scrollY) {
        navBar.classList.add('scrolled');
        scrollHint.classList.add('scrolled');

        if (window.scrollY >= scrollHeight - window.innerHeight - 100) {
          cta.classList.remove('show');
        } else if (window.scrollY > window.innerHeight) {
          cta.classList.add('show');
        }
      } else {
        navBar.classList.remove('scrolled');
        scrollHint.classList.remove('scrolled');
        cta.classList.remove('show');
      }
    });

    const scrollTop = document.getElementById('scroll-top');
    if (scrollTop) {
      scrollTop.onclick = function(ev) {
        ev.preventDefault();
        ev.stopPropagation();

        jQuery('html, body').animate({
          scrollTop: 0
        }, 1000);
      }
    }
  }

  if (document.readyState !== 'loading') {
    loaded();
  } else {
    document.addEventListener('DOMContentLoaded', loaded);
  }
})();

var onThumbnailClick = function(
  index: number, items: { src: string; w: number; h: number; }[], event: Event
) {
  event.preventDefault();

  var pswpElement = document.querySelectorAll('.pswp')[0];

  if (pswpElement) {
    var options = {
      index: index
    };

    var gallery = new PhotoSwipe(
      pswpElement, PhotoSwipeUI_Default, items, options
    );
    gallery.init();
  }
}
window['onThumbnailClick'] = onThumbnailClick;
